import React from 'react';

import Field, { Props as FieldProps } from '../Field/Field';
import Input, { Props as InputProps } from 'components/inputs/DatePicker/DatePicker';

const DatePicker: React.FC<FieldProps & InputProps> = ({ ...rest }) => {
  const showTime = rest.showTime ?? true;

  const dataType = rest.range ? 'dateRange' : showTime ? 'datetime' : 'date';
  const props = { ...rest, dataType };
  return <Field {...props} component={Input} />;
};

DatePicker.displayName = 'DatePicker';
export default DatePicker;
